<template>
  <div name="AnnouncementDetail">
    <Pagenation
      v-if="showPagenation"
      :index="index"
      :total="total"
      @showOther="showOther"
      @showList="showList"
    >
    </Pagenation>
    <b-container>
      <b-row>
        <b-col cols="12" lg="8" class="info px-3">
          <AnnouncementDetailInfo
            @click-reply="handleClickReply($event)"
            @click-favorite="handleClickFavorite($event)"
            />
        </b-col>
        <b-col cols="12" lg="4" class="comments px-3">
          <b-card class="mb-4">
          <Comments
          @click-profile="handleClickProfile"/>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import AnnouncementDetailInfo from '@/components/Announcement/AnnouncementDetailInfo'
import Comments from '@/components/Announcement/AnnouncementDetailComments'
import Pagenation from '@/components/Pagenation.vue'
import { getReplyList } from '@/transformer/announcement.js'
import { mapGetters } from 'vuex'

export default {
  name: 'AnnouncementDetail',

  components: {
    AnnouncementDetailInfo,
    Pagenation,
    Comments
  },

  props: {
    index: Number,
    total: Number,
    showPagenation: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  computed: {
    ...mapGetters('Announcement/', ['selectedAnnouncement'])
  },
  methods: {
    getReplyFields: function (showAll = true) {
      return [
        { key: 'name', label: '名前', sortable: showAll, textSearch: true },
        { key: 'reply', label: '返信', sortable: showAll, selectSearch: getReplyList(this.selectedAnnouncement) },
        { key: 'comment', label: 'コメント', sortable: showAll, textSearch: true }
      ]
    },
    handleClickReply($event) {
      this.$emit('click-reply', $event)
    },
    handleClickFavorite($event) {
      this.$emit('click-favorite', $event)
    },
    handleClickProfile($event) {
      this.$emit('click-profile', $event)
    },
    showOther(index) {
      this.$emit('showOther', index)
    },
    showList() {
      this.$emit('showList')
    },
    formChanged(data) {
      this.selectedAnnouncement[data.id] = data.value
    },
    checkRead() {
      // 未読なら既読にする
      if (Number(this.selectedAnnouncement.status === '0') && Number(this.selectedAnnouncement.announcement_id) > 0) {
        const announcementId = this.selectedAnnouncement.announcement_id
        this.$emit('read', announcementId)
      }
    }
  },
  watch: {
    selectedAnnouncement() {
      this.checkRead()
    }
  },
  mounted() {
    this.checkRead()
  }
}
</script>
